export default "__VITE_ASSET__BBzBzENB__"